import React from 'react';
import { Bar, BarChart as RechartBarChart, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

export interface BarChartData {
  data: any[]
  keys: string[]
}

interface BarChartProps {
  width: number
  height: number
  data: BarChartData
  getFillByKey?: (key: any) => string
}

const BarChart: React.FC<BarChartProps> = ({ width, height, data, getFillByKey }) => (
  <ResponsiveContainer
    width="100%"
    height={height}
  >
    <RechartBarChart
      width={width}
      height={height}
      data={data.data}
    >
      <Tooltip />
      <Legend />
      <XAxis
        dataKey="name"
      />      
      <YAxis />
      {data.keys.map(key => (
        <Bar          
          key={key}
          dataKey={key}
          fill={getFillByKey!(key)}
        />
      ))}      
    </RechartBarChart>
  </ResponsiveContainer>
)

export default BarChart
